module.exports = __webpack_public_path__ + "static/media/g6.ebf0b9d3.jpg";